import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";
import {
  RptTransportationSummaryTableDefault,
  columns as rptTransportationSummaryColumns,
} from "./RptTransportationSummaryTableDefault";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptTransportationSummary extends Component {
  static displayName = RptTransportationSummary.name;

  constructor(props) {
    super(props);
    this.state = {
      rptTransportationSummaryList: [],
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        StartDate: "",
        EndDate: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));

    this.renderRptTransportationSummary =
      this.renderRptTransportationSummary.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportTransportationSummary =
      this.exportTransportationSummary.bind(this);
    //
  }

  componentDidMount() {}

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateTransportationSummaryReportData();
    }
  }

  async populateTransportationSummaryReportData() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrpttransportationsummary",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        rptTransportationSummaryList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  exportTransportationSummary() {
    exportRowsToExcel({
      rows: this.state.rptTransportationSummaryList,
      columns: rptTransportationSummaryColumns,
      fileName: "TransportationSummaryReport.xlsx",
    });
  }

  renderRptTransportationSummary(rptTransportationSummary) {
    return (
      <RptTransportationSummaryTableDefault
        rptTransportationSummary={this.state.rptTransportationSummaryList}
      ></RptTransportationSummaryTableDefault>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptTransportationSummary(this.state.rptTransportationSummaryList)
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Transportation Summary Report</h5>
        <Row className="align-items-center g-2">
          <Col className="col-4">
            <InputGroup size="sm">
              <InputGroupText>Start Date</InputGroupText>
              <input
                name="StartDate"
                ref={(ref) => (this.txtStartDate = ref)}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.StartDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="Start Date"
                onKeyDown={this.handleKeyDown}
              />
              <InputGroupText>End Date</InputGroupText>
              <input
                name="EndDate"
                ref={(input) => {
                  this.EndDate = input;
                }}
                type="date"
                className="form-control form-control-text"
                value={this.state.searchModel.EndDate}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                onBlur={this.handleSearchBlur}
                placeholder="End Date"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportTransportationSummary}
                title="Export Transportation Summary Report"
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <div>{contents}</div>
      </div>
    );
  }
}
